import core, { GQL } from '@gin-betting/core';

import { favoritePages } from 'app-constants';

const { isOneOfPages } = core.utils;

export default function getSportEventTypesByLocation() {
    if (isOneOfPages(favoritePages.outright)) {
        return [GQL.SportEventType.OUTRIGHT];
    }

    return [GQL.SportEventType.MATCH];
}
